import { toAbsoluteImageUrl } from '@/shared/libs/helpers';
import dayjs from 'dayjs';

export function videoSchema(product) {
  let title = product.title?.trim();
  const serialTitle = product.season?.serial?.title?.trim();

  if (serialTitle && serialTitle !== title) {
    title = `${serialTitle} ${title}`;
  }

  const jsonLinkedData = {
    '@context': 'https://schema.org/',
    '@type': 'VideoObject',
    name: title,
    description: product.description,
    contentUrl: product.canonicalUrl,
    thumbnailUrl: [
      product?.images?.['16x9']?.[0]?.mainUrl,
      product?.images?.['1x1']?.[0]?.mainUrl,
      product?.images?.['3x4']?.[0]?.mainUrl,
    ].map(toAbsoluteImageUrl).filter(Boolean),
    uploadDate: new Date(product.since).toISOString(),
  };

  if (product.duration) {
    jsonLinkedData.duration = dayjs.duration(product.duration, 's').toISOString();
  }

  const scriptElement = document.getElementById('scriptJSON');

  if (scriptElement) {
    scriptElement.innerText = JSON.stringify(jsonLinkedData);
  }
}
